import React from 'react';

/**
 * en-ca disclaimer
 */
const enCaDisclaimer = {
  header: 'Disclaimer:',
  text: (
    <p>
      Please be advised that not all devices shown on the website are currently
      licensed for sale in Canada; and may only be sold after a medical device
      license for the device has been issued by Health Canada in accordance with
      the Food and Drug Act and Medical Devices Regulations. Safety and efficacy
      claims of non-licensed products have not been reviewed by Health Canada
      and are subject to change.
    </p>
  ),
  cookieName: 'en-ca-disclaimer',
  acceptText: 'Accept',
  declineText: 'Decline',
  declinePath: '/',
};

/**
 * fr-ca disclaimer
 */
const frCaDisclaimer = {
  header: 'Avis de non-responsabilité',
  text: (
    <p>
      Veuillez noter que les dispositifs présentés sur le site Web ne sont pas
      tous homologués pour la vente au Canada et qu'ils ne peuvent être vendus
      qu'après avoir été homologués par Santé Canada, conformément à la Loi sur
      les aliments et drogues et au Règlement sur les instruments médicaux. Les
      allégations de sécurité et d'efficacité des produits non homologués n'ont
      pas été examinées par Santé Canada et sont susceptibles d'être modifiées.
    </p>
  ),
  cookieName: 'fr-ca-disclaimer',
  acceptText: 'Accepter',
  declineText: 'Refuser',
  declinePath: '/',
};

/**
 * Turkey disclaimer
 */
const trDisclaimer = {
  header: "Varian Türkiye'ye hoş geldiniz.",
  text: (
    <p>
      Sonraki sayfalardaki bilgilerin sağlık meslek mensuplarına yönelik
      olduğunu belirtmek isteriz. Onaylıyorum butonuna tıklayarak, bu bilgileri
      dikkate aldığınızı ve sağlık uzmanı olduğunuzu teyit etmiş olursunuz.
    </p>
  ),
  cookieName: 'tr-disclaimer',
  acceptText: 'Onaylıyorum',
  declineText: 'İptal',
  declinePath: '/tr/about-varian/varian-turkey/varian-turkey/',
};

/**
 * Tandem Distributor disclaimer
 */
const tandemDisclaimer = {
  header: (
    <>
      TANDEM&reg; Microspheres <br /> Distributor Support
    </>
  ),
  text: (
    <>
      <p>
        Welcome to the Varian TANDEM&reg; Microspheres Distributor Support site.
        The content is for Varian Distributors outside of the United States
        only. TANDEM has not received FDA clearance or approval and is therefore
        not available for use in the United States. Please refer to the TANDEM
        regulatory labeling for your region for indications, complete safety
        information, warnings, precautions and contraindications.
      </p>
      <p>
        <strong>
          Do not share the information on the website with physicians or
          distributors outside of your assigned territory. Please confirm you
          are a Varian Distributor outside of the United States and will comply
          with the statement above.
        </strong>
      </p>
    </>
  ),
  cookieName: 'tandem-declaimer',
  acceptText: 'Yes',
  declineText: 'No',
  declinePath: '/',
};

/**
 * Australasia disclaimer
 */
const auLocalDisclaimer = {
  header: 'Varian Australasia',
  text: (
    <p>
      You are entering Varian Australasia office page. By continuing you agree
      you are a Healthcare Professional or have a professional interest in
      Varian products.
    </p>
  ),
  cookieName: 'au-local',
  acceptText: 'Continue',
  declineText: 'Corporate Website',
  declinePath: '/',
};

/**
 * Disclaimer Data
 */
export const disclaimerData = {
  'en-ca-disclaimer': enCaDisclaimer,
  'fr-ca-disclaimer': frCaDisclaimer,
  'tr-disclaimer': trDisclaimer,
  'tandem-disclaimer': tandemDisclaimer,
  'au-local-disclaimer': auLocalDisclaimer,
};
